import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderTypeXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForTrailerType: HorizontalSpacer;
    labelCrossRef: Label;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    panelOrderType: Panel;
    sourceEdiCrossRefOrderType: DataSource;
    tableCrossRef: Table;
}
